 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		378: 0,
 		277: 0,
 		278: 0,
 		281: 0,
 		329: 0,
 		330: 0,
 		336: 0,
 		337: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","215":"AddClosedAlertIDUseCase","216":"CreateDeviceUseCase","217":"CreateDomestikaFollowUseCase","218":"CreateJWTUserUseCase","219":"CreateUserLiveSessionUseCase","220":"CurrentUserUseCase","221":"CurrentWithoutRelationshipsUserUseCase","222":"DeleteDeviceUseCase","223":"DeleteFollowUseCase","224":"ENV_CONFIG1","225":"ENV_CONFIG4","226":"ENV_CONFIG5","227":"ENV_CONFIG6","228":"ENV_CONFIG7","229":"FinishUserLiveSessionUseCase","230":"GetAccessTokenUserUseCase","231":"GetAdvanceGDPRStatusUserUseCase","232":"GetAllBlogUseCase","233":"GetAreasCourseUseCase","234":"GetCartCourseUseCase","235":"GetCategoriesCourseUseCase","236":"GetCourseUseCase","237":"GetFinalProjectVideoByCourseIDCourseUseCase","238":"GetGDPRStatusUserUseCase","239":"GetListLiveFeedbackQuestionUseCase","240":"GetListLiveSessionUseCase","241":"GetListLiveStreamUseCase","242":"GetLiveChannelUseCase","243":"GetLiveSessionUseCase","244":"GetOrganizationUseCase","245":"GetPlusPromotionUseCase","246":"GetPostContentBlogUseCase","247":"GetPromotionCodeAlertUseCase","248":"GetPromotionUseCase","249":"GetPubnubCredentialsUseCase","250":"GetSessionDataUserUseCase","251":"GetSimpleUserUseCase","252":"GetSoftwaresCourseUseCase","253":"GetUserAlertUseCase","254":"GetVideoProgressListCourseUseCase","255":"GetVideoSpeedUserUseCase","256":"GetVideoVolumeUserUseCase","257":"LogoutUserUseCase","258":"PathToRegexp","259":"RefreshAccessTokenUserUseCase","260":"RemoveAccessTokenUserUseCase","261":"SearchCourseUseCase","262":"SendHeaderTrackingUseCase","263":"SendLiveFeedbackAnswersUseCase","264":"SendPlayerTrackingUseCase","265":"SendTrackingUseCase","266":"SendVideoProgressCourseUseCase","267":"SetAdvanceGDPRStatusUserUseCase","268":"SetGDPRStatusUserUseCase","269":"SetVideoSpeedUserUseCase","270":"SetVideoVolumeUserUseCase","271":"UpdateLanguageUserUseCase","272":"UpdateLiveSessionUseCase","273":"UpdateVideoAudioAndSubtitlesCourseUseCase","274":"UpdateVideoProgressCourseUseCase","275":"ViewPageTrackingUseCase","335":"vendors~AddClosedAlertIDUseCase","336":"vendors~AlgoliaSearch","337":"vendors~AmplitudeJS","338":"vendors~SearchCourseUseCase","339":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"c5fd7c83ce9fe61e3de7","1":"bcf2597fcba5f534ab90","2":"23362500c7abfc97d6d8","3":"2668f0b4ff23eaae4be1","4":"56a4324ed58aa9743ea2","5":"61c9f01c52e0bac7e56b","215":"3664a5bbee776cfa5200","216":"101c2a67117875bd6b88","217":"bb3cb6e6ea7f02981eaf","218":"60e7251ef0a8d26b317d","219":"0ff2e80840ed2461e438","220":"84f90f2095941febe26a","221":"ffb8bceeafd3fdde6a62","222":"1cce11c9a770f794391d","223":"7fe513650f7dc299320d","224":"83b14695d0286720da67","225":"798ffce9ba2f45696e7a","226":"5e2fffc8695524724102","227":"9d0595f0d6ddbfeaa381","228":"41fb686647f6e7db764c","229":"773354aa22ad9c14926c","230":"44de3193f16795370f94","231":"232ad4ce87503600946e","232":"9e8d79e889a88df15e2a","233":"98c7ce3480d955fb6212","234":"a5c286a6e984f92ae45d","235":"94709135125a36bd605b","236":"c64aa24d5fda09afc887","237":"caf2441490d329fb3b48","238":"6e4d0945139ff57dc2df","239":"fbd035ffdf0812aeda0b","240":"0d22f492951d546ade09","241":"65fbbab51a3ebfc190e0","242":"e354309193606cda845a","243":"4a2b3a9c1e1ebd375424","244":"ef2d75f1aa1736dd84b5","245":"7bab6d83a850b651234b","246":"988ab94750adda4a78b5","247":"ed04b6104fed51e63321","248":"c219fddd1cff6a1accd5","249":"4e3afd40d8029f765e17","250":"3e0e3ce33a4933c35908","251":"86e2151537d5d0547642","252":"67db57a371649ee67516","253":"232930fbac3f4714833b","254":"9503d6437b0cafb0370e","255":"d3fc0556a19b58df3076","256":"1efe1aa515f5508acbfc","257":"76ca79f53c880d4c152d","258":"f643df357a836857dd73","259":"51b3112e7b6e7533cb2d","260":"6b453b28754981d0771c","261":"e85d64986f7a2743142e","262":"9daa5f7f302e4f7d1a8e","263":"59e1d04c5babf1802b4a","264":"d45a505f70d36b32ab00","265":"d128c1186fa5b599580f","266":"2ca1d47614f66ecbcdb1","267":"e78a725b1cdbcfb99144","268":"4fd9a1a7f10337bf10d2","269":"088c3b6a172979ccdce0","270":"64a6f7d22709464bfa96","271":"39e06b9d328b14f7b7c1","272":"8c880e76ce8c434d7aad","273":"568521c6e470327dca71","274":"7da736fb5c64a1920d72","275":"0cdf8c206eda9570f580","335":"dfa9f10f661d85812a5f","336":"28aa647b8d664ebe3b57","337":"a100fb1d55e73379bab9","338":"d55130563bdbad3b5121","339":"0aa1079fef646ff73588","413":"6f0a2ef442f376fd8e7b","631":"d36eaec0db2cbc9c148e","632":"0bce386d2710156b5fed"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2320);
